import locale from '@com/core/common/utils/locale';
import { DOMAIN } from '@com/core/common/baseConfig';

const isBrowser: boolean = typeof window !== 'undefined';
export type TApp =
    | 'www'
    | 'www-alt'
    | 'account'
    | 'account-alt'
    | 'checkout'
    | 'checkout-alt'
    | 'login'
    | 'login-alt'
    | 'ofd'
    | 'ofd-alt'
    | 'shipments'
    | 'shipments-alt';

export const formattedRedirectUrl = (app: TApp, path: string): string =>
    `https://${app}.${DOMAIN}.com/${locale.getSEOLocale()}/${path || ''}`;

export const redirect = (path = '', app: TApp = 'www'): void => {
    let redirectURL = '';
    let appLocation = app;
    if (isBrowser) {
        const urlSegments = window.location.hostname.split('.');
        const isAlt = urlSegments[0].includes('-alt');
        appLocation = isAlt ? (`${appLocation}-alt` as TApp) : appLocation;
    }
    redirectURL = formattedRedirectUrl(appLocation, path);
    window.location.href = redirectURL;
};

export const isExternalLink = (url: string): boolean => /^https?:\/\//.test(url);

export const setBrowserState = (url: string, replaceState = false): void => {
    if (!isBrowser) return;

    const title = 'noon';

    if (replaceState) {
        // eslint-disable-next-line no-restricted-globals
        history.replaceState({}, title, url);
    } else {
        // eslint-disable-next-line no-restricted-globals
        history.pushState({}, title, url);
    }
};
